// extracted by mini-css-extract-plugin
export default {"root":"StripePaymentAddress_root__U7C3f","formRow":"StripePaymentAddress_formRow__ty2sF","field":"StripePaymentAddress_field__0CvPX"};